<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <div class="row">
    <div class="col-md-12">
      <div class="page-breadcrumb">
        <!-- new -->
        <ul class="page-breadcrumb__trail">
          <li><a>Manage</a></li>
          <li><a>Devices</a></li>
          <li><a>Tracking</a></li>
        </ul>
      </div>
      <div class="block">
        <div class="page-header">
          <span class="page-header__title">Device Tracking</span>
        </div>
        <!-- START FORM VALIDATION STATES -->
        <div class="Reports_form_div">
          <form class="form-horizontal" id="myForm" role="form" novalidate [formGroup]="form">
            <div class="reports-form-container">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Device Serial Number</mat-label>
                <mat-select id="deviceSNO" formControlName="deviceField" name="deviceSNO"
                            [(ngModel)]="device.serial_number">
                  <mat-option value="undefined" disabled>Select Device Serial Number</mat-option>
                  <mat-option *ngFor="let device of devices" [value]="device.serial_number">
                    {{ device.serial_number }}
                  </mat-option>
                </mat-select>
                <mat-hint *ngIf="f.deviceField.invalid"><i>Select device serial number</i></mat-hint>
                <mat-hint *ngIf="f.deviceField.valid"><i>Device serial number selected</i></mat-hint>
                <mat-error *ngIf="(submitted || f.deviceField.touched || f.deviceField.dirty) && f.deviceField.errors">
                  <i *ngIf="f.deviceField.hasError('required')">Required.</i>
                </mat-error>
              </mat-form-field>
            </div>
          </form>
          <div class="buttons-div reports_search_div">
            <div class="transactions-button-container" (click)="deviceTracking()">
              <button class="transaction-submit-button" [disabled]="submitButtonDisabled">
                <span class="icon"><img src="../../../../../../assets/images/New_Icons/search-icon.svg"></span>
                <span class="text">Search</span>
              </button>
            </div>
          </div>
        </div>
        <!-- END FORM VALIDATION STATES -->
        <div *ngIf="responseLoader">
          <div class="adjust loader-container">
            <div class="loader2"></div>
          </div>
        </div>
        <div class="reports_block" *ngIf="!responseLoader && isSubmitClicked && dupDeviceMovements?.length > 0">
          <div class="table-responsive" id="zoomView" *ngIf="deviceMovements?.length > 0">
            <table class="table table-striped table-bordered table-hover text-centre">
              <thead>
              <tr>
                <th>S.No</th>
                <th>AQU Device Number</th>
                <th>AQU Serial Number</th>
                <th>TINTO Device Number</th>
                <th>TINTO Serial Number</th>
                <th>Action Date</th>
                <th>Action</th>
                <th>Details</th>
              </tr>
              </thead>
              <tbody>
              <tr
                *ngFor="let list of deviceMovements; let i = index">
                <td>{{i + 1}}</td>
                <td>{{list && list.device && list.device.number}}</td>
                <td>{{list && list.device && list.device.serial_number}}</td>
                <td>
                  {{list && list.device && list.device.CustomerDeviceData && list.device.CustomerDeviceData[0] && list.device.CustomerDeviceData[0].calorimeterDevice && list.device.CustomerDeviceData[0].calorimeterDevice.number ? list.device.CustomerDeviceData[0].calorimeterDevice.number : ' --NA--' }}
                </td>
                <td>
                  {{list && list.device && list.device.CustomerDeviceData && list.device.CustomerDeviceData[0] && list.device.CustomerDeviceData[0].calorimeterDevice && list.device.CustomerDeviceData[0].calorimeterDevice.serial_number ? list.device.CustomerDeviceData[0].calorimeterDevice.serial_number : ' --NA--' }}
                </td>
                <td>{{list && list.date}}</td>
                <td>{{list && list.action_name}}</td>
                <td>{{list && list.to}}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="reports_block" *ngIf="dupDeviceMovements?.length <= 0 && isSubmitClicked">
          <div class="noDataFoundMessage">Data Not Available</div>
        </div>
      </div>
    </div>
  </div>
  <!-- END PAGE CONTENT WRAPPER -->
</div>
<!-- END PAGE CONTENT WRAPPER -->
